/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useParams } from "react-router-dom";
import { Button } from "@nordcloud/gnui";
import { AddEnvironmentSidebar } from "~/views/applications/AddApplicationPage/EnvironmentSidebars";
import { RouteParams } from "../types";

type Props = {
  ownerId: string;
};

export function AddEnvironment({ ownerId }: Props) {
  const { application = "" } = useParams<RouteParams>();
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  return (
    <>
      <Button
        severity="medium"
        icon="plus"
        mr="1rem"
        onClick={() => {
          setIsSidebarOpen(!isSidebarOpen);
        }}
      >
        Add application Environment
      </Button>
      <AddEnvironmentSidebar
        setIsSidebarOpen={setIsSidebarOpen}
        isSidebarOpen={isSidebarOpen}
        applicationNid={application}
        applicationOwnerId={ownerId}
      />
    </>
  );
}
